export class UsersTableColumns {
    static Name = {
        maxWidth: '20%',
        translateKey: 'user.name',
    };
    static Email = {
        maxWidth: '30%',
        translateKey: 'user.email',
    };
    static DateCreated = {
        maxWidth: '18%',
        translateKey: 'user.dateCreated',
    };
    static LastLogin = {
        maxWidth: '18%',
        translateKey: 'user.lastLogin',
    };
    static Status = {
        maxWidth: '10%',
        translateKey: 'user.status',
    };
    static Actions = {
        maxWidth: '4%',
        translateKey: '',
    };
}
